import init from './init';
import kickstart, { kickstarters } from './kickstart';
import getSpecDetails, { generateFingerprint } from './getSpecsDetails';
import goto, { fixURLHistory }from './goto';
import gotoRoutes from './gotoRoutes';
import getLocation from './getLocation';
import getOptins from './getOptins';
import checkCalendar, {
    getAppName,
} from './calendar';
import launchOauthPage, { generateInAppState} from './launchOauthPage';
import initAsOAuth from './initAsOauth';
import pollOauthWindow from './pollOauthWindow';
import openDeviceCalendar from './openDeviceCalendar';
import initAsInAppRedirect from './initAsInAppRedirect';
import initWithSession from './initWithSession';
import gaEventsActions from './gaEventsActions';
import getGAParams from './getGAParams';
import initGTAG from './gaInitGTag';
import trackAndLog  from './trackAndLog';
import launchFromDirectLink from './launchFromDirectLink';
import launchWidget from './launchWidget';
import setSyncAction from './setSyncAction';
import goback from './goback';
import updateWidgetSettings from './updateWidgetSettings';
import setupDynamicWidget from './setupDynamicWidget';
import selectTranslation from './selectTranslation';

export const actions = {
    ...gaEventsActions,
    ...kickstarters,
    initGTAG,
    init,
    getSpecDetails,
    goto,
    goback,
    getLocation,
    getOptins,
    checkCalendar,
    initAsOAuth,
    launchOauthPage,
    pollOauthWindow,
    openDeviceCalendar,
    generateInAppState,
    initAsInAppRedirect,
    initWithSession,
    getGAParams,
    trackAndLog,
    kickstart,
    launchFromDirectLink,
    launchWidget,
    setSyncAction,
    updateWidgetSettings,
    setupDynamicWidget,
    fixURLHistory,
    getAppName,
    generateFingerprint,
    selectTranslation,
    ...gotoRoutes,
};

export default actions;
